import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import './TermsOfService.css';

function TermsOfService() {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/terms-of-service.md')
      .then(response => response.text())
      .then(text => {
        setContent(text);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error loading terms of service:', error);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <div className="terms-of-service">
        <div className="content">
          <p>読み込み中...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="terms-of-service">
      <div className="content">
        <ReactMarkdown remarkPlugins={[remarkGfm]}>
          {content}
        </ReactMarkdown>
      </div>
    </div>
  );
}

export default TermsOfService;